<template>
  <div>
    <ItemPage
      :title="title"
      size="md"
      :actions="actions"
    >
      <div
        class="negativeContainer my-5"
      >
        <v-expansion-panels
          v-model="panel"
          multiple
        >
          <v-expansion-panel>
            <v-expansion-panel-header>Matérias do curso</v-expansion-panel-header>
            <v-expansion-panel-content>
              <gradeSubjects
                ref="gradeSubject"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Volumes do curso</v-expansion-panel-header>
            <v-expansion-panel-content>
              <gradeVolumes
                ref="gradeVolume"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Tópicos do curso</v-expansion-panel-header>
            <v-expansion-panel-content>
              <gradeUnits
                ref="gradeUnit"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </ItemPage>
  </div>
</template>

<script>
import ItemPage from '@/components/pages/ItemPage.vue'
import gradeSubjects from './components/gradeSubjects.vue'
import gradeVolumes from './components/gradeVolumes.vue'
import gradeUnits from './components/gradeUnits.vue'

import handlesServerValidation from '@/mixins/handles-server-validation.js'

export default {
  components: {
    ItemPage,
    gradeSubjects,
    gradeVolumes,
    gradeUnits
  },

  mixins: [
    handlesServerValidation
  ],

  data () {
    return {
      title: 'Curso',
      grade: null,
      panel: [0, 1, 2]
    }
  },

  computed: {
    id () {
      return this.$route.params.gradeID
    },
    actions () {
      return [
        {
          label: 'Adicionar Tópico',
          action: this.openNewUnit,
          icon: 'mdi-plus',
          disabled: this.gradeSubjectView
        },
        {
          label: 'Adicionar Matéria',
          action: this.openNewSubject,
          icon: 'mdi-plus',
          disabled: this.gradeSubjectView
        },
        {
          label: 'Adicionar Volume',
          action: this.openNewVolume,
          icon: 'mdi-plus',
          disabled: this.gradeSubjectView
        }
      ]
    }
  },
  async mounted () {
    await this.fetchAll()
  },
  methods: {
    async fetchAll () {
      try {
        this.grade = await this.$api.getGrades(this.id)
        this.title = this.grade.short_name + ' - ' + this.grade.education_stage.short_name + ' - ' + this.grade.education_system.short_name
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter o curso, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e)
      }
    },
    openNewSubject () {
      this.$refs.gradeSubject.openFormAddNewitemDIalog()
    },
    openNewVolume () {
      this.$refs.gradeVolume.openFormAddNewitemDIalog()
    },
    openNewUnit () {
      this.$refs.gradeUnit.openFormAddNewitemDIalog()
    }
  }
}
</script>
<style scoped>
.negativeContainer {
  margin: -32px;
  border-left: 0px;
  border-right: 0px;
}
</style>
